module.exports = __webpack_public_path__ + "img/TamNguyen.e862a7b4.jpeg";